import { useCanAsMember } from './useCanAsMember';

/**
 * `true` when the active membership can read the org's profile (the API guards
 * /profile and /dashboard/inicio with `org:read-dashboard`). Single source of
 * truth for the "Ver estudio" menu entry, the /sistema/organizacion page and
 * Inicio, so they cannot drift apart.
 */
export function useCanReadOrgProfile() {
  return useCanAsMember('org:read-dashboard');
}
